import tw from 'twin.macro'
import React, { useContext } from 'react'
import { MCPaymentsTableContext } from '../payments-table/MCPaymentsTable.context'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { MCPaymentStatusSelect } from './MCPaymentStatusSelect'
import { MCPaymentsBatchActionButton } from './action/MCPaymentsBatchActionButton'
import { UserPermission } from 'src/constants/user'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'

export const MCPaymentsHeader = () => {
  const {
    setSearchQuery,
    searchQuery,
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(MCPaymentsTableContext)

  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center gap-4 px-4 py-3 bg-white rounded-t-lg border-0 border-b border-solid border-[#EDEDED]`}
    >
      {columnsConfig.length > 0 && (
        <GridColumnsSelect
          columnsConfig={columnsConfig}
          columnVisibilityModel={columnVisibilityModel}
          pinnedColumns={pinnedColumns}
          lockedColumns={lockedColumns}
          onToggleColumnVisibility={onToggleColumnVisibility}
          onColumnVisibilityModelChange={onColumnVisibilityModelChange}
          onPinColumn={onPinColumn}
          onUnpinColumn={onUnpinColumn}
        />
      )}
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        inputDataTestId="payments-mc-main-search-input"
        clearButtonDataTestId="payments-mc-main-search-clear-btn"
      />
      <MCPaymentStatusSelect />
      {hasPermission(UserPermission.PaymentsDelete) && <MCPaymentsBatchActionButton />}
    </div>
  )
}
